module.exports = __webpack_public_path__ + "img/home.8b15c1d9.svg";